import { useState } from 'react';
import {
  Modal,
  Typography,
  Box,
  Button,
  Backdrop,
  Fade,
  CardMedia,
} from '@mui/material';

// import { Container } from './styles';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '100%',
  maxHeight: 'auto',
  minWidth: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

export default function VizualizadorImagem({ arquivo }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen}>
        <CardMedia component="img" height={120} image={arquivo} />
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <CardMedia component="img" image={arquivo} />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
